// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var List = require("bs-platform/lib/js/list.js");
var Block = require("bs-platform/lib/js/block.js");
var Curry = require("bs-platform/lib/js/curry.js");
var Format = require("bs-platform/lib/js/format.js");
var Random = require("bs-platform/lib/js/random.js");
var Hashtbl = require("bs-platform/lib/js/hashtbl.js");
var Caml_obj = require("bs-platform/lib/js/caml_obj.js");
var Caml_int32 = require("bs-platform/lib/js/caml_int32.js");
var Pervasives = require("bs-platform/lib/js/pervasives.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var Caml_builtin_exceptions = require("bs-platform/lib/js/caml_builtin_exceptions.js");

function is_empty(param) {
  if (param) {
    return false;
  } else {
    return true;
  }
}

function map(f, l) {
  var direct = function (f, i, l) {
    if (l) {
      var match = l[1];
      var x = l[0];
      if (match) {
        var match$1 = match[1];
        var x2 = match[0];
        if (match$1) {
          if (match$1[1]) {
            if (i === 0) {
              var f$1 = f;
              var l$1 = l;
              var _tuple_acc = /* [] */0;
              var _xs = l$1;
              while(true) {
                var xs = _xs;
                var tuple_acc = _tuple_acc;
                if (xs) {
                  var match$2 = xs[1];
                  if (match$2) {
                    var match$3 = match$2[1];
                    if (match$3) {
                      var match$4 = match$3[1];
                      if (match$4) {
                        var match$5 = match$4[1];
                        if (match$5) {
                          var match$6 = match$5[1];
                          if (match$6) {
                            var match$7 = match$6[1];
                            if (match$7) {
                              var match$8 = match$7[1];
                              if (match$8) {
                                var match$9 = match$8[1];
                                if (match$9) {
                                  var y0 = Curry._1(f$1, xs[0]);
                                  var y1 = Curry._1(f$1, match$2[0]);
                                  var y2 = Curry._1(f$1, match$3[0]);
                                  var y3 = Curry._1(f$1, match$4[0]);
                                  var y4 = Curry._1(f$1, match$5[0]);
                                  var y5 = Curry._1(f$1, match$6[0]);
                                  var y6 = Curry._1(f$1, match$7[0]);
                                  var y7 = Curry._1(f$1, match$8[0]);
                                  var y8 = Curry._1(f$1, match$9[0]);
                                  _xs = match$9[1];
                                  _tuple_acc = /* :: */[
                                    /* tuple */[
                                      y0,
                                      y1,
                                      y2,
                                      y3,
                                      y4,
                                      y5,
                                      y6,
                                      y7,
                                      y8
                                    ],
                                    tuple_acc
                                  ];
                                  continue ;
                                }
                                
                              }
                              
                            }
                            
                          }
                          
                        }
                        
                      }
                      
                    }
                    
                  }
                  
                }
                var tail = List.map(f$1, xs);
                var _tail_acc = tail;
                var _param = tuple_acc;
                while(true) {
                  var param = _param;
                  var tail_acc = _tail_acc;
                  if (param) {
                    var match$10 = param[0];
                    _param = param[1];
                    _tail_acc = /* :: */[
                      match$10[0],
                      /* :: */[
                        match$10[1],
                        /* :: */[
                          match$10[2],
                          /* :: */[
                            match$10[3],
                            /* :: */[
                              match$10[4],
                              /* :: */[
                                match$10[5],
                                /* :: */[
                                  match$10[6],
                                  /* :: */[
                                    match$10[7],
                                    /* :: */[
                                      match$10[8],
                                      tail_acc
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ];
                    continue ;
                  } else {
                    return tail_acc;
                  }
                };
              };
            } else {
              var match$11 = l[1];
              var match$12 = match$11[1];
              var match$13 = match$12[1];
              var y1$1 = Curry._1(f, l[0]);
              var y2$1 = Curry._1(f, match$11[0]);
              var y3$1 = Curry._1(f, match$12[0]);
              var y4$1 = Curry._1(f, match$13[0]);
              return /* :: */[
                      y1$1,
                      /* :: */[
                        y2$1,
                        /* :: */[
                          y3$1,
                          /* :: */[
                            y4$1,
                            direct(f, i - 1 | 0, match$13[1])
                          ]
                        ]
                      ]
                    ];
            }
          } else {
            var y1$2 = Curry._1(f, x);
            var y2$2 = Curry._1(f, x2);
            return /* :: */[
                    y1$2,
                    /* :: */[
                      y2$2,
                      /* :: */[
                        Curry._1(f, match$1[0]),
                        /* [] */0
                      ]
                    ]
                  ];
          }
        } else {
          var y1$3 = Curry._1(f, x);
          return /* :: */[
                  y1$3,
                  /* :: */[
                    Curry._1(f, x2),
                    /* [] */0
                  ]
                ];
        }
      } else {
        return /* :: */[
                Curry._1(f, x),
                /* [] */0
              ];
      }
    } else {
      return /* [] */0;
    }
  };
  return direct(f, 1000, l);
}

function $great$pipe$eq(l, f) {
  return map(f, l);
}

function cons(x, l) {
  return /* :: */[
          x,
          l
        ];
}

function append(l1, l2) {
  var direct = function (i, l1, l2) {
    if (l1) {
      if (i === 0) {
        return List.rev_append(List.rev(l1), l2);
      } else {
        return /* :: */[
                l1[0],
                direct(i - 1 | 0, l1[1], l2)
              ];
      }
    } else {
      return l2;
    }
  };
  if (l1) {
    var match = l1[1];
    var x = l1[0];
    if (match) {
      if (match[1]) {
        return direct(10000, l1, l2);
      } else {
        return /* :: */[
                x,
                /* :: */[
                  match[0],
                  l2
                ]
              ];
      }
    } else {
      return /* :: */[
              x,
              l2
            ];
    }
  } else {
    return l2;
  }
}

function cons_maybe(o, l) {
  if (o !== undefined) {
    return /* :: */[
            Caml_option.valFromOption(o),
            l
          ];
  } else {
    return l;
  }
}

function filter(p, l) {
  var direct = function (i, p, _l) {
    while(true) {
      var l = _l;
      if (l) {
        if (i === 0) {
          var p$1 = p;
          var _l$1 = l;
          var _acc = /* [] */0;
          while(true) {
            var acc = _acc;
            var l$1 = _l$1;
            if (l$1) {
              var l$prime = l$1[1];
              var x = l$1[0];
              if (Curry._1(p$1, x)) {
                _acc = /* :: */[
                  x,
                  acc
                ];
                _l$1 = l$prime;
                continue ;
              } else {
                _l$1 = l$prime;
                continue ;
              }
            } else {
              return List.rev(acc);
            }
          };
        } else {
          var l$prime$1 = l[1];
          var x$1 = l[0];
          if (Curry._1(p, x$1)) {
            return /* :: */[
                    x$1,
                    direct(i - 1 | 0, p, l$prime$1)
                  ];
          } else {
            _l = l$prime$1;
            continue ;
          }
        }
      } else {
        return /* [] */0;
      }
    };
  };
  return direct(10000, p, l);
}

function fold_right(f, l, acc) {
  var direct = function (i, f, l, acc) {
    if (l) {
      if (i === 0) {
        var f$1 = f;
        var _l = List.rev(l);
        var _acc = acc;
        while(true) {
          var acc$1 = _acc;
          var l$1 = _l;
          if (l$1) {
            var acc$2 = Curry._2(f$1, l$1[0], acc$1);
            _acc = acc$2;
            _l = l$1[1];
            continue ;
          } else {
            return acc$1;
          }
        };
      } else {
        var acc$3 = direct(i - 1 | 0, f, l[1], acc);
        return Curry._2(f, l[0], acc$3);
      }
    } else {
      return acc;
    }
  };
  return direct(1000, f, l, acc);
}

function fold_while(f, _acc, _param) {
  while(true) {
    var param = _param;
    var acc = _acc;
    if (param) {
      var match = Curry._2(f, acc, param[0]);
      var acc$1 = match[0];
      if (match[1] >= 926227490) {
        return acc$1;
      } else {
        _param = param[1];
        _acc = acc$1;
        continue ;
      }
    } else {
      return acc;
    }
  };
}

function fold_map(f, acc, l) {
  var f$1 = f;
  var _acc = acc;
  var _map_acc = /* [] */0;
  var _l = l;
  while(true) {
    var l$1 = _l;
    var map_acc = _map_acc;
    var acc$1 = _acc;
    if (l$1) {
      var match = Curry._2(f$1, acc$1, l$1[0]);
      _l = l$1[1];
      _map_acc = /* :: */[
        match[1],
        map_acc
      ];
      _acc = match[0];
      continue ;
    } else {
      return /* tuple */[
              acc$1,
              List.rev(map_acc)
            ];
    }
  };
}

function scan_left(f, acc, l) {
  var f$1 = f;
  var _acc = acc;
  var _l_acc = /* :: */[
    acc,
    /* [] */0
  ];
  var _l = l;
  while(true) {
    var l$1 = _l;
    var l_acc = _l_acc;
    var acc$1 = _acc;
    if (l$1) {
      var acc$2 = Curry._2(f$1, acc$1, l$1[0]);
      var l_acc$1 = /* :: */[
        acc$2,
        l_acc
      ];
      _l = l$1[1];
      _l_acc = l_acc$1;
      _acc = acc$2;
      continue ;
    } else {
      return List.rev(l_acc);
    }
  };
}

function fold_map2(f, acc, l1, l2) {
  var f$1 = f;
  var _acc = acc;
  var _map_acc = /* [] */0;
  var _l1 = l1;
  var _l2 = l2;
  while(true) {
    var l2$1 = _l2;
    var l1$1 = _l1;
    var map_acc = _map_acc;
    var acc$1 = _acc;
    if (l1$1) {
      if (l2$1) {
        var match = Curry._3(f$1, acc$1, l1$1[0], l2$1[0]);
        _l2 = l2$1[1];
        _l1 = l1$1[1];
        _map_acc = /* :: */[
          match[1],
          map_acc
        ];
        _acc = match[0];
        continue ;
      } else {
        return Pervasives.invalid_arg("fold_map2");
      }
    } else if (l2$1) {
      return Pervasives.invalid_arg("fold_map2");
    } else {
      return /* tuple */[
              acc$1,
              List.rev(map_acc)
            ];
    }
  };
}

function fold_filter_map(f, acc, l) {
  var f$1 = f;
  var _acc = acc;
  var _map_acc = /* [] */0;
  var _l = l;
  while(true) {
    var l$1 = _l;
    var map_acc = _map_acc;
    var acc$1 = _acc;
    if (l$1) {
      var match = Curry._2(f$1, acc$1, l$1[0]);
      _l = l$1[1];
      _map_acc = cons_maybe(match[1], map_acc);
      _acc = match[0];
      continue ;
    } else {
      return /* tuple */[
              acc$1,
              List.rev(map_acc)
            ];
    }
  };
}

function fold_flat_map(f, acc, l) {
  var f$1 = f;
  var _acc = acc;
  var _map_acc = /* [] */0;
  var _l = l;
  while(true) {
    var l$1 = _l;
    var map_acc = _map_acc;
    var acc$1 = _acc;
    if (l$1) {
      var match = Curry._2(f$1, acc$1, l$1[0]);
      _l = l$1[1];
      _map_acc = List.rev_append(match[1], map_acc);
      _acc = match[0];
      continue ;
    } else {
      return /* tuple */[
              acc$1,
              List.rev(map_acc)
            ];
    }
  };
}

function init(len, f) {
  if (len < 0) {
    return Pervasives.invalid_arg("init");
  } else if (len === 0) {
    return /* [] */0;
  } else {
    var _acc = /* [] */0;
    var _i = len - 1 | 0;
    var f$1 = f;
    while(true) {
      var i = _i;
      var acc = _acc;
      if (i === 0) {
        return /* :: */[
                Curry._1(f$1, i),
                acc
              ];
      } else {
        _i = i - 1 | 0;
        _acc = /* :: */[
          Curry._1(f$1, i),
          acc
        ];
        continue ;
      }
    };
  }
}

function compare(f, _l1, _l2) {
  while(true) {
    var l2 = _l2;
    var l1 = _l1;
    if (l1) {
      if (l2) {
        var c = Curry._2(f, l1[0], l2[0]);
        if (c !== 0) {
          return c;
        } else {
          _l2 = l2[1];
          _l1 = l1[1];
          continue ;
        }
      } else {
        return 1;
      }
    } else if (l2) {
      return -1;
    } else {
      return 0;
    }
  };
}

function equal(f, _l1, _l2) {
  while(true) {
    var l2 = _l2;
    var l1 = _l1;
    if (l1) {
      if (l2 && Curry._2(f, l1[0], l2[0])) {
        _l2 = l2[1];
        _l1 = l1[1];
        continue ;
      } else {
        return false;
      }
    } else if (l2) {
      return false;
    } else {
      return true;
    }
  };
}

function flat_map(f, l) {
  var f$1 = f;
  var _l = l;
  var _kont = function (l) {
    return l;
  };
  while(true) {
    var kont = _kont;
    var l$1 = _l;
    if (l$1) {
      var y = Curry._1(f$1, l$1[0]);
      var kont$prime = (function(kont,y){
      return function kont$prime(tail) {
        if (y) {
          var match = y[1];
          var x = y[0];
          if (match) {
            if (match[1]) {
              return Curry._1(kont, append(y, tail));
            } else {
              return Curry._1(kont, /* :: */[
                          x,
                          /* :: */[
                            match[0],
                            tail
                          ]
                        ]);
            }
          } else {
            return Curry._1(kont, /* :: */[
                        x,
                        tail
                      ]);
          }
        } else {
          return Curry._1(kont, tail);
        }
      }
      }(kont,y));
      _kont = kont$prime;
      _l = l$1[1];
      continue ;
    } else {
      return Curry._1(kont, /* [] */0);
    }
  };
}

function flatten(l) {
  return fold_right(append, l, /* [] */0);
}

function count(f, l) {
  return List.fold_left((function (n, x) {
                if (Curry._1(f, x)) {
                  return n + 1 | 0;
                } else {
                  return n;
                }
              }), 0, l);
}

function count_true_false(p, l) {
  return List.fold_left((function (param, x) {
                var ko = param[1];
                var ok = param[0];
                if (Curry._1(p, x)) {
                  return /* tuple */[
                          ok + 1 | 0,
                          ko
                        ];
                } else {
                  return /* tuple */[
                          ok,
                          ko + 1 | 0
                        ];
                }
              }), /* tuple */[
              0,
              0
            ], l);
}

function product(f, l1, l2) {
  return flat_map((function (x) {
                return map((function (y) {
                              return Curry._2(f, x, y);
                            }), l2);
              }), l1);
}

function fold_product(f, acc, l1, l2) {
  return List.fold_left((function (acc, x1) {
                return List.fold_left((function (acc, x2) {
                              return Curry._3(f, acc, x1, x2);
                            }), acc, l2);
              }), acc, l1);
}

function diagonal(l) {
  var _acc = /* [] */0;
  var _l = l;
  while(true) {
    var l$1 = _l;
    var acc = _acc;
    if (l$1) {
      var l$prime = l$1[1];
      var x = l$1[0];
      var acc$1 = List.fold_left((function(x){
          return function (acc, y) {
            return /* :: */[
                    /* tuple */[
                      x,
                      y
                    ],
                    acc
                  ];
          }
          }(x)), acc, l$prime);
      _l = l$prime;
      _acc = acc$1;
      continue ;
    } else {
      return acc;
    }
  };
}

function partition_map(f, l) {
  var f$1 = f;
  var _l1 = /* [] */0;
  var _l2 = /* [] */0;
  var _l = l;
  while(true) {
    var l$1 = _l;
    var l2 = _l2;
    var l1 = _l1;
    if (l$1) {
      var tl = l$1[1];
      var match = Curry._1(f$1, l$1[0]);
      _l = tl;
      if (typeof match === "number") {
        continue ;
      } else if (match[0] >= 847852583) {
        _l1 = /* :: */[
          match[1],
          l1
        ];
        continue ;
      } else {
        _l2 = /* :: */[
          match[1],
          l2
        ];
        continue ;
      }
    } else {
      return /* tuple */[
              List.rev(l1),
              List.rev(l2)
            ];
    }
  };
}

function combine(l1, l2) {
  var direct = function (i, l1, l2) {
    if (!l1 && !l2) {
      return /* [] */0;
    }
    if (i === 0) {
      var _l1 = l1;
      var _l2 = l2;
      var _acc = /* [] */0;
      while(true) {
        var acc = _acc;
        var l2$1 = _l2;
        var l1$1 = _l1;
        if (l1$1) {
          if (l2$1) {
            _acc = /* :: */[
              /* tuple */[
                l1$1[0],
                l2$1[0]
              ],
              acc
            ];
            _l2 = l2$1[1];
            _l1 = l1$1[1];
            continue ;
          } else {
            return Pervasives.invalid_arg("CCList.combine");
          }
        } else if (l2$1) {
          return Pervasives.invalid_arg("CCList.combine");
        } else {
          return List.rev(acc);
        }
      };
    } else if (l1 && l2) {
      return /* :: */[
              /* tuple */[
                l1[0],
                l2[0]
              ],
              direct(i - 1 | 0, l1[1], l2[1])
            ];
    } else {
      return Pervasives.invalid_arg("CCList.combine");
    }
  };
  return direct(1000, l1, l2);
}

function combine_gen(l1, l2) {
  var l1$1 = {
    contents: l1
  };
  var l2$1 = {
    contents: l2
  };
  return (function (param) {
      var match = l1$1.contents;
      var match$1 = l2$1.contents;
      if (match && match$1) {
        l1$1.contents = match[1];
        l2$1.contents = match$1[1];
        return /* tuple */[
                match[0],
                match$1[0]
              ];
      }
      
    });
}

function split(l) {
  var direct = function (i, l) {
    if (l) {
      var match = l[1];
      var match$1 = l[0];
      var y1 = match$1[1];
      var x1 = match$1[0];
      if (match) {
        var match$2 = match[1];
        var match$3 = match[0];
        var y2 = match$3[1];
        var x2 = match$3[0];
        if (match$2) {
          var match$4 = match$2[1];
          var match$5 = match$2[0];
          var y3 = match$5[1];
          var x3 = match$5[0];
          if (match$4) {
            if (match$4[1]) {
              if (i === 0) {
                var _acc1 = /* [] */0;
                var _acc2 = /* [] */0;
                var _l = l;
                while(true) {
                  var l$1 = _l;
                  var acc2 = _acc2;
                  var acc1 = _acc1;
                  if (l$1) {
                    var match$6 = l$1[0];
                    var acc1_000 = match$6[0];
                    var acc1$1 = /* :: */[
                      acc1_000,
                      acc1
                    ];
                    var acc2_000 = match$6[1];
                    var acc2$1 = /* :: */[
                      acc2_000,
                      acc2
                    ];
                    _l = l$1[1];
                    _acc2 = acc2$1;
                    _acc1 = acc1$1;
                    continue ;
                  } else {
                    return /* tuple */[
                            List.rev(acc1),
                            List.rev(acc2)
                          ];
                  }
                };
              } else {
                var match$7 = l[1];
                var match$8 = match$7[1];
                var match$9 = match$8[1];
                var match$10 = match$9[1];
                var match$11 = match$10[0];
                var match$12 = match$9[0];
                var match$13 = match$8[0];
                var match$14 = match$7[0];
                var match$15 = l[0];
                var match$16 = direct(i - 1 | 0, match$10[1]);
                return /* tuple */[
                        /* :: */[
                          match$15[0],
                          /* :: */[
                            match$14[0],
                            /* :: */[
                              match$13[0],
                              /* :: */[
                                match$12[0],
                                /* :: */[
                                  match$11[0],
                                  match$16[0]
                                ]
                              ]
                            ]
                          ]
                        ],
                        /* :: */[
                          match$15[1],
                          /* :: */[
                            match$14[1],
                            /* :: */[
                              match$13[1],
                              /* :: */[
                                match$12[1],
                                /* :: */[
                                  match$11[1],
                                  match$16[1]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ];
              }
            } else {
              var match$17 = match$4[0];
              return /* tuple */[
                      /* :: */[
                        x1,
                        /* :: */[
                          x2,
                          /* :: */[
                            x3,
                            /* :: */[
                              match$17[0],
                              /* [] */0
                            ]
                          ]
                        ]
                      ],
                      /* :: */[
                        y1,
                        /* :: */[
                          y2,
                          /* :: */[
                            y3,
                            /* :: */[
                              match$17[1],
                              /* [] */0
                            ]
                          ]
                        ]
                      ]
                    ];
            }
          } else {
            return /* tuple */[
                    /* :: */[
                      x1,
                      /* :: */[
                        x2,
                        /* :: */[
                          x3,
                          /* [] */0
                        ]
                      ]
                    ],
                    /* :: */[
                      y1,
                      /* :: */[
                        y2,
                        /* :: */[
                          y3,
                          /* [] */0
                        ]
                      ]
                    ]
                  ];
          }
        } else {
          return /* tuple */[
                  /* :: */[
                    x1,
                    /* :: */[
                      x2,
                      /* [] */0
                    ]
                  ],
                  /* :: */[
                    y1,
                    /* :: */[
                      y2,
                      /* [] */0
                    ]
                  ]
                ];
        }
      } else {
        return /* tuple */[
                /* :: */[
                  x1,
                  /* [] */0
                ],
                /* :: */[
                  y1,
                  /* [] */0
                ]
              ];
      }
    } else {
      return /* tuple */[
              /* [] */0,
              /* [] */0
            ];
    }
  };
  return direct(1000, l);
}

function $$return(x) {
  return /* :: */[
          x,
          /* [] */0
        ];
}

function $great$great$eq(l, f) {
  return flat_map(f, l);
}

function $less$star$great(funs, l) {
  return product((function (f, x) {
                return Curry._1(f, x);
              }), funs, l);
}

function cartesian_product(l) {
  var prod_rec = function (left, right, k, acc) {
    if (right) {
      var tail = right[1];
      return List.fold_left((function (acc, x) {
                    return prod_rec(/* :: */[
                                x,
                                left
                              ], tail, k, acc);
                  }), acc, right[0]);
    } else {
      return Curry._2(k, acc, List.rev(left));
    }
  };
  return prod_rec(/* [] */0, l, (function (acc, l$prime) {
                return /* :: */[
                        l$prime,
                        acc
                      ];
              }), /* [] */0);
}

function map_product_l(f, l) {
  return cartesian_product(List.map(f, l));
}

function sorted_merge(cmp, l1, l2) {
  var cmp$1 = cmp;
  var _acc = /* [] */0;
  var _l1 = l1;
  var _l2 = l2;
  while(true) {
    var l2$1 = _l2;
    var l1$1 = _l1;
    var acc = _acc;
    if (l1$1) {
      if (l2$1) {
        var l2$prime = l2$1[1];
        var x2 = l2$1[0];
        var l1$prime = l1$1[1];
        var x1 = l1$1[0];
        var c = Curry._2(cmp$1, x1, x2);
        if (c < 0) {
          _l1 = l1$prime;
          _acc = /* :: */[
            x1,
            acc
          ];
          continue ;
        } else {
          _l2 = l2$prime;
          if (c > 0) {
            _acc = /* :: */[
              x2,
              acc
            ];
            continue ;
          } else {
            _l1 = l1$prime;
            _acc = /* :: */[
              x1,
              /* :: */[
                x2,
                acc
              ]
            ];
            continue ;
          }
        }
      } else {
        return List.rev_append(acc, l1$1);
      }
    } else {
      return List.rev_append(acc, l2$1);
    }
  };
}

var sort_uniq = List.sort_uniq;

function is_sorted(cmp, l) {
  var cmp$1 = cmp;
  var _param = l;
  while(true) {
    var param = _param;
    if (param) {
      var tail = param[1];
      if (tail) {
        if (Curry._2(cmp$1, param[0], tail[0]) <= 0) {
          _param = tail;
          continue ;
        } else {
          return false;
        }
      } else {
        return true;
      }
    } else {
      return true;
    }
  };
}

function sorted_insert(cmp, $staropt$star, x, l) {
  var uniq = $staropt$star !== undefined ? $staropt$star : false;
  var cmp$1 = cmp;
  var uniq$1 = uniq;
  var x$1 = x;
  var _left = /* [] */0;
  var _l = l;
  while(true) {
    var l$1 = _l;
    var left = _left;
    if (l$1) {
      var y = l$1[0];
      var n = Curry._2(cmp$1, x$1, y);
      if (n !== 0) {
        if (n < 0) {
          return List.rev_append(left, /* :: */[
                      x$1,
                      l$1
                    ]);
        } else {
          _l = l$1[1];
          _left = /* :: */[
            y,
            left
          ];
          continue ;
        }
      } else {
        var l$prime = uniq$1 ? l$1 : /* :: */[
            x$1,
            l$1
          ];
        return List.rev_append(left, l$prime);
      }
    } else {
      return List.rev_append(left, /* :: */[
                  x$1,
                  /* [] */0
                ]);
    }
  };
}

function uniq_succ(eq, l) {
  var _acc = /* [] */0;
  var _l = l;
  while(true) {
    var l$1 = _l;
    var acc = _acc;
    if (l$1) {
      var tail = l$1[1];
      var x = l$1[0];
      if (tail) {
        if (Curry._2(eq, x, tail[0])) {
          _l = tail;
          continue ;
        } else {
          _l = tail;
          _acc = /* :: */[
            x,
            acc
          ];
          continue ;
        }
      } else {
        return List.rev(/* :: */[
                    x,
                    acc
                  ]);
      }
    } else {
      return List.rev(acc);
    }
  };
}

function group_succ(eq, l) {
  var eq$1 = eq;
  var _acc = /* [] */0;
  var _cur = /* [] */0;
  var _l = l;
  while(true) {
    var l$1 = _l;
    var cur = _cur;
    var acc = _acc;
    if (cur) {
      if (l$1) {
        var x = l$1[0];
        if (Curry._2(eq$1, x, cur[0])) {
          _l = l$1[1];
          _cur = /* :: */[
            x,
            cur
          ];
          continue ;
        } else {
          _l = l$1[1];
          _cur = /* :: */[
            l$1[0],
            /* [] */0
          ];
          _acc = /* :: */[
            List.rev(cur),
            acc
          ];
          continue ;
        }
      } else {
        return List.rev(/* :: */[
                    List.rev(cur),
                    acc
                  ]);
      }
    } else if (l$1) {
      _l = l$1[1];
      _cur = /* :: */[
        l$1[0],
        /* [] */0
      ];
      continue ;
    } else {
      return List.rev(acc);
    }
  };
}

function sorted_merge_uniq(cmp, l1, l2) {
  var push = function (cmp, acc, x) {
    if (acc) {
      if (Curry._2(cmp, x, acc[0]) > 0) {
        return /* :: */[
                x,
                acc
              ];
      } else {
        return acc;
      }
    } else {
      return /* :: */[
              x,
              /* [] */0
            ];
    }
  };
  var cmp$1 = cmp;
  var _acc = /* [] */0;
  var _l1 = l1;
  var _l2 = l2;
  while(true) {
    var l2$1 = _l2;
    var l1$1 = _l1;
    var acc = _acc;
    if (l1$1) {
      if (l2$1) {
        var l2$prime = l2$1[1];
        var x2 = l2$1[0];
        var x1 = l1$1[0];
        var c = Curry._2(cmp$1, x1, x2);
        if (c < 0) {
          _l1 = l1$1[1];
          _acc = push(cmp$1, acc, x1);
          continue ;
        } else {
          _l2 = l2$prime;
          if (c > 0) {
            _acc = push(cmp$1, acc, x2);
            continue ;
          } else {
            continue ;
          }
        }
      } else {
        return List.rev(List.fold_left((function (param, param$1) {
                          return push(cmp$1, param, param$1);
                        }), acc, l1$1));
      }
    } else {
      return List.rev(List.fold_left((function (param, param$1) {
                        return push(cmp$1, param, param$1);
                      }), acc, l2$1));
    }
  };
}

function take(n, l) {
  var direct = function (i, n, l) {
    if (l) {
      if (i === 0) {
        var _n = n;
        var _acc = /* [] */0;
        var _l = l;
        while(true) {
          var l$1 = _l;
          var acc = _acc;
          var n$1 = _n;
          if (l$1 && n$1 !== 0) {
            _l = l$1[1];
            _acc = /* :: */[
              l$1[0],
              acc
            ];
            _n = n$1 - 1 | 0;
            continue ;
          } else {
            return List.rev(acc);
          }
        };
      } else if (n > 0) {
        return /* :: */[
                l[0],
                direct(i - 1 | 0, n - 1 | 0, l[1])
              ];
      } else {
        return /* [] */0;
      }
    } else {
      return /* [] */0;
    }
  };
  return direct(1000, n, l);
}

function drop(_n, _l) {
  while(true) {
    var l = _l;
    var n = _n;
    if (l) {
      if (n === 0) {
        return l;
      } else {
        _l = l[1];
        _n = n - 1 | 0;
        continue ;
      }
    } else {
      return /* [] */0;
    }
  };
}

function hd_tl(param) {
  if (param) {
    return /* tuple */[
            param[0],
            param[1]
          ];
  } else {
    return Pervasives.failwith("hd_tl");
  }
}

function take_drop(n, l) {
  return /* tuple */[
          take(n, l),
          drop(n, l)
        ];
}

function sublists_of_len($staropt$star, offset, n, l) {
  var last = $staropt$star !== undefined ? $staropt$star : (function (param) {
        return ;
      });
  if (n < 1) {
    Pervasives.invalid_arg("sublists_of_len: n must be > 0");
  }
  var offset$1;
  if (offset !== undefined) {
    var o = offset;
    offset$1 = o < 1 ? Pervasives.invalid_arg("sublists_of_len: offset must be > 0") : o;
  } else {
    offset$1 = n;
  }
  var aux = function (_acc, _l) {
    while(true) {
      var l = _l;
      var acc = _acc;
      var group = take(n, l);
      if (is_empty(group)) {
        return acc;
      } else if (List.length(group) < n) {
        var match = Curry._1(last, group);
        if (match !== undefined) {
          return /* :: */[
                  match,
                  acc
                ];
        } else {
          return acc;
        }
      } else {
        var l$prime = drop(offset$1, l);
        _l = l$prime;
        _acc = /* :: */[
          group,
          acc
        ];
        continue ;
      }
    };
  };
  return List.rev(aux(/* [] */0, l));
}

function intersperse(x, l) {
  var aux_direct = function (i, x, l) {
    if (l) {
      if (l[1]) {
        if (i === 0) {
          var _acc = /* [] */0;
          var x$1 = x;
          var _l = l;
          while(true) {
            var l$1 = _l;
            var acc = _acc;
            if (l$1) {
              var tail = l$1[1];
              var y = l$1[0];
              if (tail) {
                _l = tail;
                _acc = /* :: */[
                  x$1,
                  /* :: */[
                    y,
                    acc
                  ]
                ];
                continue ;
              } else {
                return List.rev(/* :: */[
                            y,
                            acc
                          ]);
              }
            } else {
              return List.rev(acc);
            }
          };
        } else {
          return /* :: */[
                  l[0],
                  /* :: */[
                    x,
                    aux_direct(i - 1 | 0, x, l[1])
                  ]
                ];
        }
      } else {
        return l;
      }
    } else {
      return /* [] */0;
    }
  };
  return aux_direct(1000, x, l);
}

function interleave(l1, l2) {
  var _acc = /* [] */0;
  var _l1 = l1;
  var _l2 = l2;
  while(true) {
    var l2$1 = _l2;
    var l1$1 = _l1;
    var acc = _acc;
    if (l1$1) {
      if (l2$1) {
        _l2 = l2$1[1];
        _l1 = l1$1[1];
        _acc = /* :: */[
          l2$1[0],
          /* :: */[
            l1$1[0],
            acc
          ]
        ];
        continue ;
      } else {
        return List.rev(List.rev_append(l1$1, acc));
      }
    } else if (l2$1) {
      return List.rev(List.rev_append(l2$1, acc));
    } else {
      return List.rev(acc);
    }
  };
}

function take_while(p, l) {
  var direct = function (i, p, l) {
    if (l) {
      if (i === 0) {
        var p$1 = p;
        var _acc = /* [] */0;
        var _l = l;
        while(true) {
          var l$1 = _l;
          var acc = _acc;
          if (l$1) {
            var x = l$1[0];
            if (Curry._1(p$1, x)) {
              _l = l$1[1];
              _acc = /* :: */[
                x,
                acc
              ];
              continue ;
            } else {
              return List.rev(acc);
            }
          } else {
            return List.rev(acc);
          }
        };
      } else {
        var x$1 = l[0];
        if (Curry._1(p, x$1)) {
          return /* :: */[
                  x$1,
                  direct(i - 1 | 0, p, l[1])
                ];
        } else {
          return /* [] */0;
        }
      }
    } else {
      return /* [] */0;
    }
  };
  return direct(1000, p, l);
}

function drop_while(p, _l) {
  while(true) {
    var l = _l;
    if (l) {
      if (Curry._1(p, l[0])) {
        _l = l[1];
        continue ;
      } else {
        return l;
      }
    } else {
      return /* [] */0;
    }
  };
}

function take_drop_while(p, l) {
  var direct = function (i, p, l) {
    if (l) {
      if (i === 0) {
        var p$1 = p;
        var _acc = /* [] */0;
        var _l = l;
        while(true) {
          var l$1 = _l;
          var acc = _acc;
          if (l$1) {
            var x = l$1[0];
            if (Curry._1(p$1, x)) {
              _l = l$1[1];
              _acc = /* :: */[
                x,
                acc
              ];
              continue ;
            } else {
              return /* tuple */[
                      List.rev(acc),
                      l$1
                    ];
            }
          } else {
            return /* tuple */[
                    List.rev(acc),
                    /* [] */0
                  ];
          }
        };
      } else {
        var x$1 = l[0];
        if (Curry._1(p, x$1)) {
          var match = direct(i - 1 | 0, p, l[1]);
          return /* tuple */[
                  /* :: */[
                    x$1,
                    match[0]
                  ],
                  match[1]
                ];
        } else {
          return /* tuple */[
                  /* [] */0,
                  l
                ];
        }
      }
    } else {
      return /* tuple */[
              /* [] */0,
              /* [] */0
            ];
    }
  };
  return direct(1000, p, l);
}

function last(n, l) {
  var len = List.length(l);
  if (len < n) {
    return l;
  } else {
    return drop(len - n | 0, l);
  }
}

function head_opt(param) {
  if (param) {
    return Caml_option.some(param[0]);
  }
  
}

function tail_opt(param) {
  if (param) {
    return param[1];
  }
  
}

function last_opt(_param) {
  while(true) {
    var param = _param;
    if (param) {
      var tail = param[1];
      if (tail) {
        _param = tail;
        continue ;
      } else {
        return Caml_option.some(param[0]);
      }
    } else {
      return ;
    }
  };
}

function find_pred_exn(p, l) {
  var match = List.find_opt(p, l);
  if (match !== undefined) {
    return Caml_option.valFromOption(match);
  } else {
    throw Caml_builtin_exceptions.not_found;
  }
}

function find_mapi(f, l) {
  var f$1 = f;
  var _i = 0;
  var _param = l;
  while(true) {
    var param = _param;
    var i = _i;
    if (param) {
      var res = Curry._2(f$1, i, param[0]);
      if (res !== undefined) {
        return res;
      } else {
        _param = param[1];
        _i = i + 1 | 0;
        continue ;
      }
    } else {
      return ;
    }
  };
}

function find_map(f, l) {
  return find_mapi((function (param) {
                return f;
              }), l);
}

function find_idx(p, l) {
  return find_mapi((function (i, x) {
                if (Curry._1(p, x)) {
                  return /* tuple */[
                          i,
                          x
                        ];
                }
                
              }), l);
}

function remove(eq, x, l) {
  var eq$1 = eq;
  var x$1 = x;
  var _acc = /* [] */0;
  var _l = l;
  while(true) {
    var l$1 = _l;
    var acc = _acc;
    if (l$1) {
      var tail = l$1[1];
      var y = l$1[0];
      if (Curry._2(eq$1, x$1, y)) {
        _l = tail;
        continue ;
      } else {
        _l = tail;
        _acc = /* :: */[
          y,
          acc
        ];
        continue ;
      }
    } else {
      return List.rev(acc);
    }
  };
}

function filter_map(f, l) {
  var _acc = /* [] */0;
  var _l = l;
  while(true) {
    var l$1 = _l;
    var acc = _acc;
    if (l$1) {
      var match = Curry._1(f, l$1[0]);
      var acc$prime = match !== undefined ? /* :: */[
          Caml_option.valFromOption(match),
          acc
        ] : acc;
      _l = l$1[1];
      _acc = acc$prime;
      continue ;
    } else {
      return List.rev(acc);
    }
  };
}

function keep_some(l) {
  return filter_map((function (x) {
                return x;
              }), l);
}

function keep_ok(l) {
  return filter_map((function (param) {
                if (param.tag) {
                  return ;
                } else {
                  return Caml_option.some(param[0]);
                }
              }), l);
}

function all_some(l) {
  try {
    return map((function (param) {
                  if (param !== undefined) {
                    return Caml_option.valFromOption(param);
                  } else {
                    throw Pervasives.Exit;
                  }
                }), l);
  }
  catch (exn){
    if (exn === Pervasives.Exit) {
      return ;
    } else {
      throw exn;
    }
  }
}

function all_ok(l) {
  var err = {
    contents: undefined
  };
  try {
    return /* Ok */Block.__(0, [map((function (param) {
                      if (param.tag) {
                        err.contents = Caml_option.some(param[0]);
                        throw Pervasives.Exit;
                      } else {
                        return param[0];
                      }
                    }), l)]);
  }
  catch (exn){
    if (exn === Pervasives.Exit) {
      var match = err.contents;
      if (match !== undefined) {
        return /* Error */Block.__(1, [Caml_option.valFromOption(match)]);
      } else {
        throw [
              Caml_builtin_exceptions.assert_failure,
              /* tuple */[
                "CCList.ml",
                1029,
                16
              ]
            ];
      }
    } else {
      throw exn;
    }
  }
}

function group_by($staropt$star, $staropt$star$1, l) {
  var hash = $staropt$star !== undefined ? $staropt$star : Hashtbl.hash;
  var eq = $staropt$star$1 !== undefined ? $staropt$star$1 : Caml_obj.caml_equal;
  var Tbl = Hashtbl.Make({
        equal: eq,
        hash: hash
      });
  var tbl = Curry._1(Tbl.create, 32);
  List.iter((function (x) {
          var l;
          try {
            l = Curry._2(Tbl.find, tbl, x);
          }
          catch (exn){
            if (exn === Caml_builtin_exceptions.not_found) {
              l = /* [] */0;
            } else {
              throw exn;
            }
          }
          return Curry._3(Tbl.replace, tbl, x, /* :: */[
                      x,
                      l
                    ]);
        }), l);
  return Curry._3(Tbl.fold, (function (param, x, acc) {
                return /* :: */[
                        x,
                        acc
                      ];
              }), tbl, /* [] */0);
}

function join(join_row, s1, s2) {
  return flat_map((function (a) {
                return filter_map(Curry._1(join_row, a), s2);
              }), s1);
}

function join_by($staropt$star, $staropt$star$1, f1, f2, merge, c1, c2) {
  var eq = $staropt$star !== undefined ? $staropt$star : Caml_obj.caml_equal;
  var hash = $staropt$star$1 !== undefined ? $staropt$star$1 : Hashtbl.hash;
  var Tbl = Hashtbl.Make({
        equal: eq,
        hash: hash
      });
  var tbl = Curry._1(Tbl.create, 32);
  List.iter((function (x) {
          var key = Curry._1(f1, x);
          return Curry._3(Tbl.add, tbl, key, x);
        }), c1);
  var res = {
    contents: /* [] */0
  };
  List.iter((function (y) {
          var key = Curry._1(f2, y);
          var xs = Curry._2(Tbl.find_all, tbl, key);
          return List.iter((function (x) {
                        var match = Curry._3(merge, key, x, y);
                        if (match !== undefined) {
                          res.contents = /* :: */[
                            Caml_option.valFromOption(match),
                            res.contents
                          ];
                          return /* () */0;
                        } else {
                          return /* () */0;
                        }
                      }), xs);
        }), c2);
  return res.contents;
}

function join_all_by($staropt$star, $staropt$star$1, f1, f2, merge, c1, c2) {
  var eq = $staropt$star !== undefined ? $staropt$star : Caml_obj.caml_equal;
  var hash = $staropt$star$1 !== undefined ? $staropt$star$1 : Hashtbl.hash;
  var Tbl = Hashtbl.Make({
        equal: eq,
        hash: hash
      });
  var tbl = Curry._1(Tbl.create, 32);
  List.iter((function (x) {
          var key = Curry._1(f1, x);
          try {
            var c = Curry._2(Tbl.find, tbl, key);
            c.ja_left = /* :: */[
              x,
              c.ja_left
            ];
            return /* () */0;
          }
          catch (exn){
            if (exn === Caml_builtin_exceptions.not_found) {
              return Curry._3(Tbl.add, tbl, key, {
                          ja_left: /* :: */[
                            x,
                            /* [] */0
                          ],
                          ja_right: /* [] */0
                        });
            } else {
              throw exn;
            }
          }
        }), c1);
  List.iter((function (y) {
          var key = Curry._1(f2, y);
          try {
            var c = Curry._2(Tbl.find, tbl, key);
            c.ja_right = /* :: */[
              y,
              c.ja_right
            ];
            return /* () */0;
          }
          catch (exn){
            if (exn === Caml_builtin_exceptions.not_found) {
              return Curry._3(Tbl.add, tbl, key, {
                          ja_left: /* [] */0,
                          ja_right: /* :: */[
                            y,
                            /* [] */0
                          ]
                        });
            } else {
              throw exn;
            }
          }
        }), c2);
  return Curry._3(Tbl.fold, (function (key, cell, res) {
                var match = Curry._3(merge, key, cell.ja_left, cell.ja_right);
                if (match !== undefined) {
                  return /* :: */[
                          Caml_option.valFromOption(match),
                          res
                        ];
                } else {
                  return res;
                }
              }), tbl, /* [] */0);
}

function group_join_by($staropt$star, $staropt$star$1, f, c1, c2) {
  var eq = $staropt$star !== undefined ? $staropt$star : Caml_obj.caml_equal;
  var hash = $staropt$star$1 !== undefined ? $staropt$star$1 : Hashtbl.hash;
  var Tbl = Hashtbl.Make({
        equal: eq,
        hash: hash
      });
  var tbl = Curry._1(Tbl.create, 32);
  List.iter((function (x) {
          return Curry._3(Tbl.replace, tbl, x, /* [] */0);
        }), c1);
  List.iter((function (y) {
          var key = Curry._1(f, y);
          try {
            var l = Curry._2(Tbl.find, tbl, key);
            return Curry._3(Tbl.replace, tbl, key, /* :: */[
                        y,
                        l
                      ]);
          }
          catch (exn){
            if (exn === Caml_builtin_exceptions.not_found) {
              return /* () */0;
            } else {
              throw exn;
            }
          }
        }), c2);
  return Curry._3(Tbl.fold, (function (k, v, l) {
                return /* :: */[
                        /* tuple */[
                          k,
                          v
                        ],
                        l
                      ];
              }), tbl, /* [] */0);
}

function mem(eq, x, l) {
  var eq$1 = eq;
  var x$1 = x;
  var _l = l;
  while(true) {
    var l$1 = _l;
    if (l$1) {
      if (Curry._2(eq$1, x$1, l$1[0])) {
        return true;
      } else {
        _l = l$1[1];
        continue ;
      }
    } else {
      return false;
    }
  };
}

function add_nodup(eq, x, l) {
  if (mem(eq, x, l)) {
    return l;
  } else {
    return /* :: */[
            x,
            l
          ];
  }
}

function remove_one(eq, x, l) {
  if (mem(eq, x, l)) {
    var eq$1 = eq;
    var x$1 = x;
    var _acc = /* [] */0;
    var _l = l;
    while(true) {
      var l$1 = _l;
      var acc = _acc;
      if (l$1) {
        var tl = l$1[1];
        var y = l$1[0];
        if (Curry._2(eq$1, x$1, y)) {
          return List.rev_append(acc, tl);
        } else {
          _l = tl;
          _acc = /* :: */[
            y,
            acc
          ];
          continue ;
        }
      } else {
        throw [
              Caml_builtin_exceptions.assert_failure,
              /* tuple */[
                "CCList.ml",
                1158,
                12
              ]
            ];
      }
    };
  } else {
    return l;
  }
}

function subset(eq, l1, l2) {
  return List.for_all((function (t) {
                return mem(eq, t, l2);
              }), l1);
}

function uniq(eq, l) {
  var eq$1 = eq;
  var _acc = /* [] */0;
  var _l = l;
  while(true) {
    var l$1 = _l;
    var acc = _acc;
    if (l$1) {
      var xs = l$1[1];
      var x = l$1[0];
      if (List.exists(Curry._1(eq$1, x), xs)) {
        _l = xs;
        continue ;
      } else {
        _l = xs;
        _acc = /* :: */[
          x,
          acc
        ];
        continue ;
      }
    } else {
      return List.rev(acc);
    }
  };
}

function union(eq, l1, l2) {
  var eq$1 = eq;
  var _acc = /* [] */0;
  var _l1 = l1;
  var l2$1 = l2;
  while(true) {
    var l1$1 = _l1;
    var acc = _acc;
    if (l1$1) {
      var xs = l1$1[1];
      var x = l1$1[0];
      if (mem(eq$1, x, l2$1)) {
        _l1 = xs;
        continue ;
      } else {
        _l1 = xs;
        _acc = /* :: */[
          x,
          acc
        ];
        continue ;
      }
    } else {
      return List.rev_append(acc, l2$1);
    }
  };
}

function inter(eq, l1, l2) {
  var eq$1 = eq;
  var _acc = /* [] */0;
  var _l1 = l1;
  var l2$1 = l2;
  while(true) {
    var l1$1 = _l1;
    var acc = _acc;
    if (l1$1) {
      var xs = l1$1[1];
      var x = l1$1[0];
      if (mem(eq$1, x, l2$1)) {
        _l1 = xs;
        _acc = /* :: */[
          x,
          acc
        ];
        continue ;
      } else {
        _l1 = xs;
        continue ;
      }
    } else {
      return List.rev(acc);
    }
  };
}

function mapi(f, l) {
  var r = {
    contents: 0
  };
  return map((function (x) {
                var y = Curry._2(f, r.contents, x);
                r.contents = r.contents + 1 | 0;
                return y;
              }), l);
}

function iteri(f, l) {
  var f$1 = f;
  var _i = 0;
  var _l = l;
  while(true) {
    var l$1 = _l;
    var i = _i;
    if (l$1) {
      Curry._2(f$1, i, l$1[0]);
      _l = l$1[1];
      _i = i + 1 | 0;
      continue ;
    } else {
      return /* () */0;
    }
  };
}

function iteri2(f, l1, l2) {
  var f$1 = f;
  var _i = 0;
  var _l1 = l1;
  var _l2 = l2;
  while(true) {
    var l2$1 = _l2;
    var l1$1 = _l1;
    var i = _i;
    if (l1$1) {
      if (l2$1) {
        Curry._3(f$1, i, l1$1[0], l2$1[0]);
        _l2 = l2$1[1];
        _l1 = l1$1[1];
        _i = i + 1 | 0;
        continue ;
      } else {
        return Pervasives.invalid_arg("iteri2");
      }
    } else if (l2$1) {
      return Pervasives.invalid_arg("iteri2");
    } else {
      return /* () */0;
    }
  };
}

function foldi(f, acc, l) {
  var f$1 = f;
  var _acc = acc;
  var _i = 0;
  var _l = l;
  while(true) {
    var l$1 = _l;
    var i = _i;
    var acc$1 = _acc;
    if (l$1) {
      var acc$2 = Curry._3(f$1, acc$1, i, l$1[0]);
      _l = l$1[1];
      _i = i + 1 | 0;
      _acc = acc$2;
      continue ;
    } else {
      return acc$1;
    }
  };
}

function foldi2(f, acc, l1, l2) {
  var f$1 = f;
  var _acc = acc;
  var _i = 0;
  var _l1 = l1;
  var _l2 = l2;
  while(true) {
    var l2$1 = _l2;
    var l1$1 = _l1;
    var i = _i;
    var acc$1 = _acc;
    if (l1$1) {
      if (l2$1) {
        var acc$2 = Curry._4(f$1, acc$1, i, l1$1[0], l2$1[0]);
        _l2 = l2$1[1];
        _l1 = l1$1[1];
        _i = i + 1 | 0;
        _acc = acc$2;
        continue ;
      } else {
        return Pervasives.invalid_arg("foldi2");
      }
    } else if (l2$1) {
      return Pervasives.invalid_arg("foldi2");
    } else {
      return acc$1;
    }
  };
}

function get_at_idx_exn(i, l) {
  var i$1 = i < 0 ? List.length(l) + i | 0 : i;
  var _i = i$1;
  var _l = l;
  while(true) {
    var l$1 = _l;
    var i$2 = _i;
    if (l$1) {
      if (i$2 === 0) {
        return l$1[0];
      } else {
        _l = l$1[1];
        _i = i$2 - 1 | 0;
        continue ;
      }
    } else {
      throw Caml_builtin_exceptions.not_found;
    }
  };
}

function get_at_idx(i, l) {
  try {
    return Caml_option.some(get_at_idx_exn(i, l));
  }
  catch (exn){
    if (exn === Caml_builtin_exceptions.not_found) {
      return ;
    } else {
      throw exn;
    }
  }
}

function set_at_idx(i, x, l0) {
  var i$1 = i < 0 ? List.length(l0) + i | 0 : i;
  var _l = l0;
  var _acc = /* [] */0;
  var _i = i$1;
  while(true) {
    var i$2 = _i;
    var acc = _acc;
    var l = _l;
    if (l) {
      var l$prime = l[1];
      if (i$2 === 0) {
        return List.rev_append(acc, /* :: */[
                    x,
                    l$prime
                  ]);
      } else {
        _i = i$2 - 1 | 0;
        _acc = /* :: */[
          l[0],
          acc
        ];
        _l = l$prime;
        continue ;
      }
    } else {
      return l0;
    }
  };
}

function insert_at_idx(i, x, l) {
  var i$1 = i < 0 ? List.length(l) + i | 0 : i;
  var _l = l;
  var _acc = /* [] */0;
  var _i = i$1;
  var x$1 = x;
  while(true) {
    var i$2 = _i;
    var acc = _acc;
    var l$1 = _l;
    if (l$1) {
      var l$prime = l$1[1];
      var y = l$1[0];
      if (i$2 === 0) {
        return List.rev_append(acc, /* :: */[
                    x$1,
                    /* :: */[
                      y,
                      l$prime
                    ]
                  ]);
      } else {
        _i = i$2 - 1 | 0;
        _acc = /* :: */[
          y,
          acc
        ];
        _l = l$prime;
        continue ;
      }
    } else {
      return List.rev_append(acc, /* :: */[
                  x$1,
                  /* [] */0
                ]);
    }
  };
}

function remove_at_idx(i, l0) {
  var i$1 = i < 0 ? List.length(l0) + i | 0 : i;
  var _l = l0;
  var _acc = /* [] */0;
  var _i = i$1;
  while(true) {
    var i$2 = _i;
    var acc = _acc;
    var l = _l;
    if (l) {
      var l$prime = l[1];
      if (i$2 === 0) {
        return List.rev_append(acc, l$prime);
      } else {
        _i = i$2 - 1 | 0;
        _acc = /* :: */[
          l[0],
          acc
        ];
        _l = l$prime;
        continue ;
      }
    } else {
      return l0;
    }
  };
}

function range_by(step, i, j) {
  if (step === 0) {
    throw [
          Caml_builtin_exceptions.invalid_argument,
          "CCList.range_by"
        ];
  }
  if (step > 0 ? i > j : i < j) {
    return /* [] */0;
  } else {
    var i$1 = i;
    var _j = Caml_int32.imul(Caml_int32.div(j - i | 0, step), step) + i | 0;
    var _acc = /* [] */0;
    while(true) {
      var acc = _acc;
      var j$1 = _j;
      if (i$1 === j$1) {
        return /* :: */[
                i$1,
                acc
              ];
      } else {
        _acc = /* :: */[
          j$1,
          acc
        ];
        _j = j$1 - step | 0;
        continue ;
      }
    };
  }
}

function range(i, j) {
  if (i <= j) {
    var i$1 = i;
    var _j = j;
    var _acc = /* [] */0;
    while(true) {
      var acc = _acc;
      var j$1 = _j;
      if (i$1 === j$1) {
        return /* :: */[
                i$1,
                acc
              ];
      } else {
        _acc = /* :: */[
          j$1,
          acc
        ];
        _j = j$1 - 1 | 0;
        continue ;
      }
    };
  } else {
    var i$2 = i;
    var _j$1 = j;
    var _acc$1 = /* [] */0;
    while(true) {
      var acc$1 = _acc$1;
      var j$2 = _j$1;
      if (i$2 === j$2) {
        return /* :: */[
                i$2,
                acc$1
              ];
      } else {
        _acc$1 = /* :: */[
          j$2,
          acc$1
        ];
        _j$1 = j$2 + 1 | 0;
        continue ;
      }
    };
  }
}

function range$prime(i, j) {
  if (i < j) {
    return range(i, j - 1 | 0);
  } else if (i === j) {
    return /* [] */0;
  } else {
    return range(i, j + 1 | 0);
  }
}

function replicate(i, x) {
  var _acc = /* [] */0;
  var _i = i;
  while(true) {
    var i$1 = _i;
    var acc = _acc;
    if (i$1 === 0) {
      return acc;
    } else {
      _i = i$1 - 1 | 0;
      _acc = /* :: */[
        x,
        acc
      ];
      continue ;
    }
  };
}

function repeat(i, l) {
  var _acc = /* [] */0;
  var _i = i;
  while(true) {
    var i$1 = _i;
    var acc = _acc;
    if (i$1 === 0) {
      return List.rev(acc);
    } else {
      _i = i$1 - 1 | 0;
      _acc = List.rev_append(l, acc);
      continue ;
    }
  };
}

function search_exn(eq, _l, x) {
  while(true) {
    var l = _l;
    if (l) {
      var match = l[0];
      if (Curry._2(eq, x, match[0])) {
        return match[1];
      } else {
        _l = l[1];
        continue ;
      }
    } else {
      throw Caml_builtin_exceptions.not_found;
    }
  };
}

function get_exn(eq, x, l) {
  return search_exn(eq, l, x);
}

function get(eq, x, l) {
  try {
    return Caml_option.some(search_exn(eq, l, x));
  }
  catch (exn){
    if (exn === Caml_builtin_exceptions.not_found) {
      return ;
    } else {
      throw exn;
    }
  }
}

function search_set(eq, _acc, _l, x, f) {
  while(true) {
    var l = _l;
    var acc = _acc;
    if (l) {
      var l$prime = l[1];
      var match = l[0];
      var y$prime = match[1];
      var x$prime = match[0];
      if (Curry._2(eq, x, x$prime)) {
        return Curry._3(f, x, Caml_option.some(y$prime), List.rev_append(acc, l$prime));
      } else {
        _l = l$prime;
        _acc = /* :: */[
          /* tuple */[
            x$prime,
            y$prime
          ],
          acc
        ];
        continue ;
      }
    } else {
      return Curry._3(f, x, undefined, acc);
    }
  };
}

function set(eq, x, y, l) {
  return search_set(eq, /* [] */0, l, x, (function (x, param, l) {
                return /* :: */[
                        /* tuple */[
                          x,
                          y
                        ],
                        l
                      ];
              }));
}

function mem$1(eq, x, l) {
  try {
    search_exn(eq, l, x);
    return true;
  }
  catch (exn){
    if (exn === Caml_builtin_exceptions.not_found) {
      return false;
    } else {
      throw exn;
    }
  }
}

function update(eq, f, x, l) {
  return search_set(eq, /* [] */0, l, x, (function (x, opt_y, rest) {
                var match = Curry._1(f, opt_y);
                if (match !== undefined) {
                  return /* :: */[
                          /* tuple */[
                            x,
                            Caml_option.valFromOption(match)
                          ],
                          rest
                        ];
                } else {
                  return rest;
                }
              }));
}

function remove$1(eq, x, l) {
  return search_set(eq, /* [] */0, l, x, (function (param, opt_y, rest) {
                if (opt_y !== undefined) {
                  return rest;
                } else {
                  return l;
                }
              }));
}

function push(l, x) {
  l.contents = /* :: */[
    x,
    l.contents
  ];
  return /* () */0;
}

function pop(l) {
  var match = l.contents;
  if (match) {
    l.contents = match[1];
    return Caml_option.some(match[0]);
  }
  
}

function pop_exn(l) {
  var match = l.contents;
  if (match) {
    l.contents = match[1];
    return match[0];
  } else {
    return Pervasives.failwith("CCList.Ref.pop_exn");
  }
}

function create(param) {
  return {
          contents: /* [] */0
        };
}

function clear(l) {
  l.contents = /* [] */0;
  return /* () */0;
}

function lift(f, l) {
  return Curry._1(f, l.contents);
}

function push_list(r, l) {
  r.contents = List.rev_append(l, r.contents);
  return /* () */0;
}

var Ref = {
  push: push,
  pop: pop,
  pop_exn: pop_exn,
  create: create,
  clear: clear,
  lift: lift,
  push_list: push_list
};

function random_len(len, g, st) {
  return init(len, (function (param) {
                return Curry._1(g, st);
              }));
}

function random(g, st) {
  var len = Random.State.$$int(st, 1000);
  return init(len, (function (param) {
                return Curry._1(g, st);
              }));
}

function random_non_empty(g, st) {
  var len = 1 + Random.State.$$int(st, 1000) | 0;
  return init(len, (function (param) {
                return Curry._1(g, st);
              }));
}

function random_choose(l) {
  if (l) {
    var len = List.length(l);
    return (function (st) {
        var i = Random.State.$$int(st, len);
        return List.nth(l, i);
      });
  } else {
    throw Caml_builtin_exceptions.not_found;
  }
}

function random_sequence(l, st) {
  return map((function (g) {
                return Curry._1(g, st);
              }), l);
}

function to_seq(l, k) {
  return List.iter(k, l);
}

function of_seq(seq) {
  var l = {
    contents: /* [] */0
  };
  Curry._1(seq, (function (x) {
          l.contents = /* :: */[
            x,
            l.contents
          ];
          return /* () */0;
        }));
  return List.rev(l.contents);
}

function to_gen(l) {
  var l$1 = {
    contents: l
  };
  return (function (param) {
      var match = l$1.contents;
      if (match) {
        l$1.contents = match[1];
        return Caml_option.some(match[0]);
      }
      
    });
}

function of_gen(g) {
  var direct = function (i, g) {
    if (i === 0) {
      var _acc = /* [] */0;
      var g$1 = g;
      while(true) {
        var acc = _acc;
        var match = Curry._1(g$1, /* () */0);
        if (match !== undefined) {
          _acc = /* :: */[
            Caml_option.valFromOption(match),
            acc
          ];
          continue ;
        } else {
          return List.rev(acc);
        }
      };
    } else {
      var match$1 = Curry._1(g, /* () */0);
      if (match$1 !== undefined) {
        return /* :: */[
                Caml_option.valFromOption(match$1),
                direct(i - 1 | 0, g)
              ];
      } else {
        return /* [] */0;
      }
    }
  };
  return direct(1000, g);
}

function to_klist(l) {
  var make = function (l, param) {
    if (l) {
      var l$prime = l[1];
      return /* `Cons */[
              748545553,
              /* tuple */[
                l[0],
                (function (param) {
                    return make(l$prime, param);
                  })
              ]
            ];
    } else {
      return /* Nil */3902385;
    }
  };
  return (function (param) {
      return make(l, param);
    });
}

function of_klist(l) {
  var direct = function (i, g) {
    if (i === 0) {
      var _acc = /* [] */0;
      var _l = g;
      while(true) {
        var l$1 = _l;
        var acc = _acc;
        var match = Curry._1(l$1, /* () */0);
        if (typeof match === "number") {
          return List.rev(acc);
        } else {
          var match$1 = match[1];
          _l = match$1[1];
          _acc = /* :: */[
            match$1[0],
            acc
          ];
          continue ;
        }
      };
    } else {
      var match$2 = Curry._1(l, /* () */0);
      if (typeof match$2 === "number") {
        return /* [] */0;
      } else {
        var match$3 = match$2[1];
        return /* :: */[
                match$3[0],
                direct(i - 1 | 0, match$3[1])
              ];
      }
    }
  };
  return direct(1000, l);
}

var Infix = {
  $great$pipe$eq: $great$pipe$eq,
  $at: append,
  $less$star$great: $less$star$great,
  $less$$great: map,
  $great$great$eq: $great$great$eq,
  $neg$neg: range,
  $neg$neg$caret: range$prime
};

function pp($staropt$star, $staropt$star$1, $staropt$star$2, pp_item, fmt, l) {
  var start = $staropt$star !== undefined ? $staropt$star : "";
  var stop = $staropt$star$1 !== undefined ? $staropt$star$1 : "";
  var sep = $staropt$star$2 !== undefined ? $staropt$star$2 : ", ";
  var print = function (fmt, _l) {
    while(true) {
      var l = _l;
      if (l) {
        var l$1 = l[1];
        var x = l[0];
        if (l$1) {
          Curry._2(pp_item, fmt, x);
          Format.pp_print_string(fmt, sep);
          Format.pp_print_cut(fmt, /* () */0);
          _l = l$1;
          continue ;
        } else {
          return Curry._2(pp_item, fmt, x);
        }
      } else {
        return /* () */0;
      }
    };
  };
  Format.pp_print_string(fmt, start);
  print(fmt, l);
  return Format.pp_print_string(fmt, stop);
}

var length = List.length;

var hd = List.hd;

var tl = List.tl;

var nth = List.nth;

var rev = List.rev;

var rev_append = List.rev_append;

var concat = List.concat;

var iter = List.iter;

var rev_map = List.rev_map;

var fold_left = List.fold_left;

var iter2 = List.iter2;

var map2 = List.map2;

var rev_map2 = List.rev_map2;

var fold_left2 = List.fold_left2;

var fold_right2 = List.fold_right2;

var for_all = List.for_all;

var exists = List.exists;

var for_all2 = List.for_all2;

var exists2 = List.exists2;

var memq = List.memq;

var find = List.find;

var find_all = List.find_all;

var partition = List.partition;

var assq = List.assq;

var mem_assq = List.mem_assq;

var remove_assq = List.remove_assq;

var sort = List.sort;

var stable_sort = List.stable_sort;

var fast_sort = List.fast_sort;

var merge = List.merge;

var empty = /* [] */0;

var $at = append;

var compare_lengths = List.compare_lengths;

var compare_length_with = List.compare_length_with;

var pure = $$return;

var $less$$great = map;

var find_pred = List.find_opt;

var find_opt = List.find_opt;

var nth_opt = List.nth_opt;

var $neg$neg = range;

var $neg$neg$caret = range$prime;

var Assoc = {
  get: get,
  get_exn: get_exn,
  set: set,
  mem: mem$1,
  update: update,
  remove: remove$1
};

var assoc = get_exn;

var assoc_opt = get;

var assq_opt = List.assq_opt;

var mem_assoc = mem$1;

var remove_assoc = remove$1;

function Traverse(funarg) {
  var map_m = function (f, l) {
    var aux = function (f, acc, l) {
      if (l) {
        var tail = l[1];
        return Curry._2(funarg.$great$great$eq, Curry._1(f, l[0]), (function (x$prime) {
                      return aux(f, /* :: */[
                                  x$prime,
                                  acc
                                ], tail);
                    }));
      } else {
        return Curry._1(funarg.$$return, List.rev(acc));
      }
    };
    return aux(f, /* [] */0, l);
  };
  var map_m_par = function (f, l) {
    if (l) {
      var x$prime = Curry._1(f, l[0]);
      var tl$prime = map_m_par(f, l[1]);
      return Curry._2(funarg.$great$great$eq, x$prime, (function (x$prime) {
                    return Curry._2(funarg.$great$great$eq, tl$prime, (function (tl$prime) {
                                  return Curry._1(funarg.$$return, /* :: */[
                                              x$prime,
                                              tl$prime
                                            ]);
                                }));
                  }));
    } else {
      return Curry._1(funarg.$$return, /* [] */0);
    }
  };
  var sequence_m = function (l) {
    return map_m((function (x) {
                  return x;
                }), l);
  };
  var fold_m = function (f, acc, l) {
    if (l) {
      var l$prime = l[1];
      return Curry._2(funarg.$great$great$eq, Curry._2(f, acc, l[0]), (function (acc$prime) {
                    return fold_m(f, acc$prime, l$prime);
                  }));
    } else {
      return Curry._1(funarg.$$return, acc);
    }
  };
  return {
          sequence_m: sequence_m,
          fold_m: fold_m,
          map_m: map_m,
          map_m_par: map_m_par
        };
}

exports.length = length;
exports.hd = hd;
exports.tl = tl;
exports.nth = nth;
exports.rev = rev;
exports.rev_append = rev_append;
exports.concat = concat;
exports.iter = iter;
exports.rev_map = rev_map;
exports.fold_left = fold_left;
exports.iter2 = iter2;
exports.map2 = map2;
exports.rev_map2 = rev_map2;
exports.fold_left2 = fold_left2;
exports.fold_right2 = fold_right2;
exports.for_all = for_all;
exports.exists = exists;
exports.for_all2 = for_all2;
exports.exists2 = exists2;
exports.memq = memq;
exports.find = find;
exports.find_all = find_all;
exports.partition = partition;
exports.assq = assq;
exports.mem_assq = mem_assq;
exports.remove_assq = remove_assq;
exports.sort = sort;
exports.stable_sort = stable_sort;
exports.fast_sort = fast_sort;
exports.merge = merge;
exports.empty = empty;
exports.is_empty = is_empty;
exports.map = map;
exports.$great$pipe$eq = $great$pipe$eq;
exports.cons = cons;
exports.append = append;
exports.cons_maybe = cons_maybe;
exports.$at = $at;
exports.filter = filter;
exports.fold_right = fold_right;
exports.fold_while = fold_while;
exports.fold_map = fold_map;
exports.scan_left = scan_left;
exports.fold_map2 = fold_map2;
exports.fold_filter_map = fold_filter_map;
exports.fold_flat_map = fold_flat_map;
exports.count = count;
exports.count_true_false = count_true_false;
exports.init = init;
exports.combine = combine;
exports.combine_gen = combine_gen;
exports.split = split;
exports.compare = compare;
exports.compare_lengths = compare_lengths;
exports.compare_length_with = compare_length_with;
exports.equal = equal;
exports.flat_map = flat_map;
exports.flatten = flatten;
exports.product = product;
exports.fold_product = fold_product;
exports.cartesian_product = cartesian_product;
exports.map_product_l = map_product_l;
exports.diagonal = diagonal;
exports.partition_map = partition_map;
exports.group_by = group_by;
exports.join = join;
exports.join_by = join_by;
exports.join_all_by = join_all_by;
exports.group_join_by = group_join_by;
exports.sublists_of_len = sublists_of_len;
exports.intersperse = intersperse;
exports.interleave = interleave;
exports.pure = pure;
exports.$less$star$great = $less$star$great;
exports.$less$$great = $less$$great;
exports.$$return = $$return;
exports.$great$great$eq = $great$great$eq;
exports.take = take;
exports.drop = drop;
exports.hd_tl = hd_tl;
exports.take_drop = take_drop;
exports.take_while = take_while;
exports.drop_while = drop_while;
exports.take_drop_while = take_drop_while;
exports.last = last;
exports.head_opt = head_opt;
exports.tail_opt = tail_opt;
exports.last_opt = last_opt;
exports.find_pred = find_pred;
exports.find_opt = find_opt;
exports.find_pred_exn = find_pred_exn;
exports.find_map = find_map;
exports.find_mapi = find_mapi;
exports.find_idx = find_idx;
exports.remove = remove;
exports.filter_map = filter_map;
exports.keep_some = keep_some;
exports.keep_ok = keep_ok;
exports.all_some = all_some;
exports.all_ok = all_ok;
exports.sorted_merge = sorted_merge;
exports.sort_uniq = sort_uniq;
exports.sorted_merge_uniq = sorted_merge_uniq;
exports.is_sorted = is_sorted;
exports.sorted_insert = sorted_insert;
exports.uniq_succ = uniq_succ;
exports.group_succ = group_succ;
exports.mapi = mapi;
exports.iteri = iteri;
exports.iteri2 = iteri2;
exports.foldi = foldi;
exports.foldi2 = foldi2;
exports.get_at_idx = get_at_idx;
exports.nth_opt = nth_opt;
exports.get_at_idx_exn = get_at_idx_exn;
exports.set_at_idx = set_at_idx;
exports.insert_at_idx = insert_at_idx;
exports.remove_at_idx = remove_at_idx;
exports.add_nodup = add_nodup;
exports.remove_one = remove_one;
exports.mem = mem;
exports.subset = subset;
exports.uniq = uniq;
exports.union = union;
exports.inter = inter;
exports.range_by = range_by;
exports.range = range;
exports.range$prime = range$prime;
exports.$neg$neg = $neg$neg;
exports.$neg$neg$caret = $neg$neg$caret;
exports.replicate = replicate;
exports.repeat = repeat;
exports.Assoc = Assoc;
exports.assoc = assoc;
exports.assoc_opt = assoc_opt;
exports.assq_opt = assq_opt;
exports.mem_assoc = mem_assoc;
exports.remove_assoc = remove_assoc;
exports.Ref = Ref;
exports.Traverse = Traverse;
exports.random = random;
exports.random_non_empty = random_non_empty;
exports.random_len = random_len;
exports.random_choose = random_choose;
exports.random_sequence = random_sequence;
exports.to_seq = to_seq;
exports.of_seq = of_seq;
exports.to_gen = to_gen;
exports.of_gen = of_gen;
exports.to_klist = to_klist;
exports.of_klist = of_klist;
exports.Infix = Infix;
exports.pp = pp;
/* Format Not a pure module */
